import { Category, Result } from "@models";
import requests from "./agent";

export const categoryService = {
  getAll: async () => {
    const response = await requests.get<Result<Category[]>>(
      "/api/Category/GetAll"
    );
    return response.result;
  },

  getByTown: async (townId: number) => {
    const response = await requests.get<Result<Category[]>>(
      "/api/Category/GetByTown",
      { params: { townId } }
    );
    return response.result;
  },
};
